module.exports = __webpack_public_path__ + "img/bg-review.a2cc5154.svg";